import gql from "graphql-tag";

/** Soft-remove / archive: active flag only. */
export default gql`
  mutation updateCarForSaleActive($id: Int!, $active: Boolean!) {
    updateCarsForSaleById(
      input: {
        id: $id
        carsForSalePatch: { active: $active }
      }
    ) {
      clientMutationId
      carsForSale {
        id
        active
      }
    }
  }
`;
